/**
 * See RMA ADM A00530
 */
export enum RmaSubclassCodes {
  NoSubclassSpecified = '997',
  // below are not used for livestock
  SmallKabuli = '025',
  LargeKabuli = '219',
}
